"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _utils = require("../utils");

var _Theme8Button = _interopRequireDefault(require("../../assets/Theme8Button.css"));

var _Button = _interopRequireDefault(require("./Button"));

var _dxcFlex = _interopRequireDefault(require("dxc-flex"));

var _is_js = _interopRequireDefault(require("is_js"));

var _bind = _interopRequireDefault(require("classnames/bind"));

var _getLinkIconUrl = _interopRequireDefault(require("./getLinkIconUrl"));

var _rgbaToObject = _interopRequireDefault(require("../rgbaToObject"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var cx = _bind["default"].bind(_Theme8Button["default"]);

var GroupButton = /*#__PURE__*/function (_React$PureComponent) {
  _inheritsLoose(GroupButton, _React$PureComponent);

  function GroupButton() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "state", {
      openMenu: false,
      openTime: 0
    });

    _defineProperty(_assertThisInitialized(_this), "handleClick", function (menu) {
      var onClick = _this.props.onClick;
      onClick && onClick(menu);

      _this.setState({
        openMenu: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderMenuIten", function () {
      var _this$props = _this.props,
          data = _this$props.data,
          language = _this$props.language,
          _this$props$ui = _this$props.ui,
          ui = _this$props$ui === void 0 ? {} : _this$props$ui;
      var menus = [].concat(data.children);
      menus.reverse();
      return menus.map(function (menu, i) {
        var title = (0, _utils.getLinkTitle)(menu, language);
        return /*#__PURE__*/_react["default"].createElement(_dxcFlex["default"], {
          horizontal: "center",
          vertical: "center",
          key: i,
          className: cx("Theme8GroupButtonMenusItem"),
          onClick: _this.handleClick.bind(_assertThisInitialized(_this), menu)
        }, /*#__PURE__*/_react["default"].createElement("div", {
          style: {
            borderColor: ui.fontColor,
            color: ui.fontColor
          }
        }, title));
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderMenu", function () {
      var openMenu = _this.state.openMenu;
      var _this$props2 = _this.props,
          data = _this$props2.data,
          _this$props2$ui = _this$props2.ui,
          ui = _this$props2$ui === void 0 ? {} : _this$props2$ui;
      if (!openMenu || data.children.length === 0) return null;
      var bgObj = (0, _rgbaToObject["default"])(ui.panelBgColor);
      var background = bgObj ? "rgba(" + bgObj.r + "," + bgObj.g + "," + bgObj.b + "," + Math.min(bgObj.a + 0.2, 1) + ")" : undefined;
      return /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          background: background
        },
        onClick: _this.onClickButton,
        className: cx("Theme8GroupButtonMenus")
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: cx("Theme8GroupButtonMenusPosition")
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: cx("Theme8GroupButtonMenusContent")
      }, _this.renderMenuIten())));
    });

    _defineProperty(_assertThisInitialized(_this), "handleMouseEnter", function () {
      if (_is_js["default"].mobile() || _is_js["default"].tablet()) return false;

      _this.setState({
        openMenu: true,
        openTime: new Date().valueOf()
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleMouseLeave", function () {
      if (_is_js["default"].mobile() || _is_js["default"].tablet()) return false;

      _this.setState({
        openMenu: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onClickButton", function () {
      var _this$state = _this.state,
          openTime = _this$state.openTime,
          openMenu = _this$state.openMenu;
      var time = new Date().valueOf();

      if (openMenu) {
        if (time - openTime > 500) {
          _this.setState({
            openMenu: false
          });
        }
      } else {
        _this.setState({
          openMenu: true,
          openTime: time
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "documentClick", function () {
      var _this$state2 = _this.state,
          openTime = _this$state2.openTime,
          openMenu = _this$state2.openMenu;

      if (openMenu) {
        var time = new Date().valueOf();

        if (time - openTime > 300) {
          _this.setState({
            openMenu: false
          });
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "renderCover", function () {
      if (!_is_js["default"].mobile() && !_is_js["default"].tablet()) return null;
      var openMenu = _this.state.openMenu;
      var data = _this.props.data;
      if (!openMenu || data.children.length === 0) return null;
      return /*#__PURE__*/_react["default"].createElement("div", {
        onClick: _this.onClickButton,
        style: {
          position: "fixed",
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
          zIndex: 4499
        }
      });
    });

    return _this;
  }

  var _proto = GroupButton.prototype;

  _proto.componentDidMount = function componentDidMount() {
    document.addEventListener("click", this.documentClick);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    document.removeEventListener("click", this.documentClick);
  };

  _proto.render = function render() {
    var _this$props3 = this.props,
        data = _this$props3.data,
        language = _this$props3.language,
        style = _this$props3.style,
        MEDIA_DOMAIN = _this$props3.MEDIA_DOMAIN,
        PUBLIC_DOMAIN = _this$props3.PUBLIC_DOMAIN,
        urlSplicing = _this$props3.urlSplicing,
        ui = _this$props3.ui;
    var title = (0, _utils.getLinkTitle)(data, language);
    var src = (0, _getLinkIconUrl["default"])(data, MEDIA_DOMAIN, PUBLIC_DOMAIN, urlSplicing);
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
      style: style,
      className: cx("Theme8GroupButton"),
      onMouseEnter: this.handleMouseEnter,
      onMouseLeave: this.handleMouseLeave
    }, this.renderMenu(), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
      ui: ui,
      title: title,
      onClick: this.onClickButton,
      style: {
        position: "absolute",
        bottom: 0
      },
      src: src
    })));
  };

  return GroupButton;
}(_react["default"].PureComponent);

var _default = GroupButton;
exports["default"] = _default;
module.exports = exports.default;